import PropTypes from 'prop-types';

export default {
  id: PropTypes.number,
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  phoneNumber: PropTypes.string,
  email: PropTypes.string,
  userType: PropTypes.number,
  disabled: PropTypes.number
};
